import React from "react";

import RestPasswordForm from "./Components/FormControl/ResetPasswordForm";

import AuthLayout from "@/Components/Layouts/Native/AuthLayout";

interface UpdatePasswordScreenProperties {
  emailAddress: string;
}

function ResetPasswordScreen({
  emailAddress,
}: UpdatePasswordScreenProperties): React.JSX.Element {
  return (
    <AuthLayout>
      <RestPasswordForm emailAddress={emailAddress} />
    </AuthLayout>
  );
}

export default ResetPasswordScreen;
